import './WeChatLogin.css'
import React, { useState, useEffect, useContext } from 'react';
import { Button, Modal, message, Popover } from 'antd';
import { nanoid } from 'nanoid';
import posthog from 'posthog-js'
import { FileCenterContext } from '@/common/components/FileCenterProvider';
import CustomEvents from '@/common/constants/customEvents';
import appConfig from '@/common/constants/app';
import URLS from '@/common/constants/url';
import UserInfoPanel from '../UserInfoPanel/UserInfoPanel';
import eventBus from '@/common/services/eventBus';
import localStorageUtil from '@/common/utils/localStorageUtil';
import { request } from '@/common/utils/utils';
import { reportCheckLoginFailed, reportOpenLoginPanel } from '@/common/utils/report';
import { Subscription } from '@/common/constants/interfaces';

let qrKey = '';
let successLoginCallback: any = null;

function WeChatLogin() {
    const { userInfo, setUserInfo, setSubscription } = useContext(FileCenterContext);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [polling, setPolling] = useState<NodeJS.Timeout | null>(null);

    const showModal = () => {
        setIsModalOpen(true);
        getQrCode();
        reportOpenLoginPanel();
    };

    useEffect(() => {
        const handleOpenLoginPanel = (param: any) => {
            if (param && param.callback) {
                successLoginCallback = param.callback;
            }
            showModal()
        };

        eventBus.on(CustomEvents.OPEN_LOGIN_PANEL, handleOpenLoginPanel);

        return () => {
            eventBus.off(CustomEvents.OPEN_LOGIN_PANEL, handleOpenLoginPanel);
        };
    }, []);

    // 获取微信登录二维码
    const getQrCode = async () => {
        qrKey = nanoid();
        setTimeout(() => {
            new (window as any).WxLogin({
                self_redirect: true,
                id: "login_container",
                appid: appConfig.WECHAT_APP_ID,
                scope: "snsapi_login",
                redirect_uri: encodeURIComponent(`${URLS.WECHAT_LOGIN_CALLBACK_URL}?qrKey=${qrKey}`),
                state: "",
                style: "",
                href: ""
            });
            startPolling(qrKey);
        }, 100)
    };

    // 轮询检查扫码状态
    const startPolling = (qrKey: string) => {
        const timer = setInterval(async () => {
            try {
                // 这里需要替换为你的后端API
                const response = await fetch(`${URLS.WECHAT_LOGIN_CHECK_PATH}?qrKey=${qrKey}`);
                const data = await response.json();

                if (data.success === true) {
                    clearInterval(timer);
                    setIsModalOpen(false);
                    // 处理登录成功后的逻辑
                    if (data.token && data.userInfo) {
                        setUserInfo(data.userInfo);
                        localStorageUtil.setItem('token', data.token);
                        localStorageUtil.setItem('userInfo', data.userInfo);
                        // 登录成功后，获取并更新最新订阅信息
                        const data2 = await request<Subscription>({ url: URLS.GET_LATEST_SUBSCRIPTION_PATH, method: 'GET' })
                        setSubscription(data2)

                        if (successLoginCallback) {
                            successLoginCallback();
                            successLoginCallback = null;
                        }
                        posthog.identify(
                            data.userInfo.id,
                            data.userInfo,
                        );
                    }
                }
            } catch (error) {
                clearInterval(timer);
                message.error('检查扫码状态失败，请点击页面【人工客服】，我们会马上处理');
                reportCheckLoginFailed(qrKey);
            }
        }, 1000);
        setPolling(timer);
    };

    useEffect(() => {
        return () => {
            if (polling) {
                clearInterval(polling);
            }
        };
    }, [polling]);

    const handleCancel = () => {
        setIsModalOpen(false);
        if (polling) {
            clearInterval(polling);
        }
    };


    return (
        <div className="wechat-login">
            {!userInfo && <Button type="primary" onClick={showModal}>登录/注册</Button>}
            {userInfo && (
                <Popover
                    content={<UserInfoPanel />}
                    trigger="hover"
                    placement="bottom"
                    arrow={true}
                >
                    <div className="user-trigger">
                        <img
                            src={userInfo?.avatar_url}
                            alt="avatar"
                            className="user-avatar-small"
                        />
                    </div>
                </Popover>
            )}

            <Modal
                title="微信扫码登录"
                open={isModalOpen}
                onCancel={handleCancel}
                footer={null}
                centered
            >
                <div id="login_container" className="qrcode-container"></div>
            </Modal>
        </div>
    );
}

export default React.memo(WeChatLogin);